var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStatisticsColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.867188,
    y: 3.92383,
    width: 2.26667,
    height: 13.0769,
    rx: 1.13333,
    fill: "url(#paint0_linear_212_7269)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.867188,
    y: 3.92383,
    width: 2.26667,
    height: 13.0769,
    rx: 1.13333,
    fill: "url(#paint1_linear_212_7269)",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5332,
    width: 2.26667,
    height: 17,
    rx: 1.13333,
    fill: "url(#paint2_linear_212_7269)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5332,
    width: 2.26667,
    height: 17,
    rx: 1.13333,
    fill: "url(#paint3_linear_212_7269)",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2012,
    y: 5.23047,
    width: 2.26667,
    height: 11.7692,
    rx: 1.13333,
    fill: "url(#paint4_linear_212_7269)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2012,
    y: 5.23047,
    width: 2.26667,
    height: 11.7692,
    rx: 1.13333,
    fill: "url(#paint5_linear_212_7269)",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8672,
    y: 2.61523,
    width: 2.26667,
    height: 14.3846,
    rx: 1.13333,
    fill: "url(#paint6_linear_212_7269)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8672,
    y: 2.61523,
    width: 2.26667,
    height: 14.3846,
    rx: 1.13333,
    fill: "url(#paint7_linear_212_7269)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_7269",
    x1: 2.00052,
    y1: 3.92383,
    x2: 2.00052,
    y2: 17.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF800B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_212_7269",
    x1: 1.98556,
    y1: -1.16083,
    x2: 2.49317,
    y2: 16.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_212_7269",
    x1: 7.66654,
    y1: 0,
    x2: 7.66654,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF800B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_212_7269",
    x1: 7.65157,
    y1: -6.61006,
    x2: 8.50897,
    y2: 16.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_212_7269",
    x1: 13.3345,
    y1: 5.23047,
    x2: 13.3345,
    y2: 16.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF800B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_212_7269",
    x1: 13.3195,
    y1: 0.654276,
    x2: 13.7308,
    y2: 16.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_212_7269",
    x1: 19.0005,
    y1: 2.61523,
    x2: 19.0005,
    y2: 16.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF800B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_212_7269",
    x1: 18.9856,
    y1: -2.97789,
    x2: 19.5997,
    y2: 16.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatisticsColor);
export default __webpack_public_path__ + "static/media/menu-statistics-color.17f26ef89920260c2cf6fa9dc3b9772d.svg";
export { ForwardRef as ReactComponent };